/*
  Copyright (C) 2026 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Saveliy Zaznobin <zaznobins@yandex.ru>, Sber
*/

export const WIZARD_NAV_KEY = 'WIZARD_NAV_PROVIDER';

export const wizardNavMixin = {
	inject: {
		wizardNav: {
			from: WIZARD_NAV_KEY,
			default: null
		}
	},
	methods: {
		setWizardNextBlocked(blocked, message = null) {
			this.wizardNav?.setBlocked(this.$.uid, blocked, message);
		}
	},
	beforeUnmount() {
		this.wizardNav?.setBlocked(this.$.uid, false);
	}
};
